import React, { useState } from "react";
import { Routes } from "./Components/Routes/Routes";
import { UserInitializer } from "./Components/UserInitializer/UserInitializer";
import { BrowserRouter } from "react-router-dom";


const App: React.FC = (): React.ReactElement => {
  const [isInitialized, setIsInitialized] = useState(false);
  if (isInitialized) {
    return (
      <BrowserRouter>
        <Routes />
      </BrowserRouter>);
  }
  return <UserInitializer setIsInitialized={setIsInitialized} />
};

export default App;
